var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resps-list"},[(_vm.loaded)?_c('active-table',{ref:"table",attrs:{"config":_vm.config,"showTableActions":false,"scope":{active: _vm.active}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }